import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as LiveIcon } from "../../assets/Icons/live.svg";
import { ReactComponent as InfoIcon } from "../../assets/Icons/info.svg";
import {ReactComponent as PrevArrow} from "../../assets/Icons/arrow-prev.svg";
import { ReactComponent as NextArrow } from "../../assets/Icons/arrow-next.svg";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import ScheduleDetailsModal from "../../Components/Modals/ScheduleDetailsModal";
import LiveEpgContainer from "./LiveEpgContainer";
import { useDispatch, useSelector } from "react-redux";
import { getVideoSubscription } from "../Subscription/service"
// import { fetchLiveChannels, fetchLiveChannels2 } from "./service";
import { fetchLiveChannels } from "./service";
import { getLiveScheduleData } from "../../Redux/LiveScheduleData/liveScheduleDataSlice";
import { convertUTCToLocal, getCurrentTime, getCurrentTimeAndDate, getDiffInMinutes, imageUrlCheck, onVideoPlayFunction, timeConversion } from "../../utils/utils";
import { getUserSubscription } from "../../network/service";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import ContinueWithSubscriptionModal from "../../Components/Modals/ContinueWithSubscriptionModal";
import parse from "html-react-parser";
import moment from "moment";
import MainLoading from "../../Components/Loading/MainLoading";
import { getSelectedSchedule } from "../../Redux/SelectedScheduleChannel/selectedScheduleChannelSlice";
import NoScheduleAvailableModal from "../../Components/Modals/NoScheduleAvailableModal";
import { fetchFastChannels } from "./service";
import LivePlayerCenter from "./LivePlayerCenter";
import Translate from "../../Components/MultiLanguage/Translate";
import { ReactComponent as RightArrow } from "../../assets/Icons/rightArrow.svg";
import { ReactComponent as PauseButton } from "../PlutoHomepage/assets/Icons/pause2.svg";
import { ReactComponent as PlayButton } from "../PlutoHomepage/assets/Icons/play2.svg";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import SwiperCore, { Navigation } from 'swiper';

let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let initialLoad = true;
const KalingoLiveChannels = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const scheduleModal = useSelector((state) => state?.scheduleModal?.value);
  const liveScheduleData = useSelector((state) => state?.liveSchedule?.value);
  const selectedSchedule = useSelector((state) => state?.selectedSchedule?.value);
  const userSubscriptionData = useSelector((state) => state?.userSubscription?.value);
  const pubid = projectInfo?.projectConfig?.pubid;
  const user = useSelector((state) => state?.user?.value);

  const [initialLoad, setInitialLoad] = useState(true);
  const [sliceCount, setSliceCount] = useState(550);
  const [channelData, setChannelData] = useState();
  const [livePlayer, setLivePlayer] = useState();
  const [isReadMore, setIsReadMore] = useState(true);
  const [timeLeft, setTimeLeft] = useState()
  const [liveUrl, setLiveUrl] = useState("")
  const [loading, setLoading] = useState(true)
  const [isReady, setIsReady] = useState(false);
  const [timerExpired, setTimerExpired] = useState(false);
  const [isContinueWithSubscriptionModal, setIsContinueWithSubscriptionModal] = useState(false);
  const [fastchannelData, setFastChannelData] = useState();
  const [isNoScheduleAvailableModal, setIsNoScheduleAvailableModal] = useState(false);
  const [categories, setCategories] = useState();
  const [categoryButton, setCategoryButton] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedCategoryName, setselectedCategoryName] = useState(categories?.[0]?.category_name || <Translate textKey={'select_category'}/>);
  const [isCategoryChange, setIsCategoryChange] = useState(false);
  const [channelPoster, setChannelPoster] = useState();
  const [isLiveVideoSub, setLiveVideoSub] = useState();
  const [videoSubscription, setVideoSubscription] = useState();
  const [subscribedUser, setSubscribedUser] = useState();
  const [isRadioLive, setIsRadioLive] = useState(false);
  const [showSubscribe, setShowSubscribe] = useState(false)
  const [isLivePlaying, setIsLivePlaying] = useState(false);
  const [isLivePaused, setIsLivePaused] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const playerRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  SwiperCore.use([Navigation]);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };
  const queryParams = new URLSearchParams(location.search);
  const c = queryParams.get('c');

  if (localStorage.getItem('initialLoaded') == 'true') {
    localStorage.removeItem('initialLoaded');
    setInitialLoad(false);
    // window.location.href = window.location.href;

  } else {
    // do nothing
  }

  // useEffect(() => {
  //   if(!selectedSchedule?.channel_id){
  //     if (liveScheduleData?.channels) {
  //       setChannelData(liveScheduleData?.channels[0]);
  //     }
  //   }
  // }, [liveScheduleData]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Use 'auto' for instant scrolling
    });
  }, [])
  useEffect(() => {
    if (projectInfo?.projectConfig?.config?.LIVE_LOGIN_REQUIRED === "true" && !user) {
      if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
        navigate("/checkout", { 
          state: { 
            ...location.state, 
            path: location?.pathname, 
          } 
        });
      } else {
        navigate("/login", { 
          state: { 
            ...location.state, 
            path: location?.pathname, 
          } 
        });
      }
      return;
    }
  }, []);

  useEffect(() => {
    if (!isCategoryChange) {
      setChannelData(null);
      setFastChannelData(null);
      setLivePlayer(null);
      setLiveUrl(null);
    }
    if (liveScheduleData) {
      if ( Object.entries(liveScheduleData).length > 0 && liveScheduleData.channels?.length > 0 && liveScheduleData?.schedules?.length > 0 ) {
        setLoading(false)
        setIsNoScheduleAvailableModal(false);

        let selectedChannelId = null;
        if (c) {
          selectedChannelId = c;
        } else if (selectedSchedule?.channel_id) {
          selectedChannelId = selectedSchedule.channel_id;
        } else if (liveScheduleData?.schedules[0]?.channel_id) {
          selectedChannelId = liveScheduleData.schedules[0].channel_id;
        }

        if (selectedChannelId) {
          const filteredChannel = liveScheduleData?.channels?.find((item) => selectedChannelId == item?.id);
          if (filteredChannel) {
            setChannelData({ ...filteredChannel, channel_id: selectedChannelId });
          }
          if (!selectedSchedule?.channel_id || selectedSchedule.channel_id != selectedChannelId) {
            dispatch(getSelectedSchedule({ selectedSchedule: { channel_id: selectedChannelId } }));
          }
        }
      }
      else {
        if (liveScheduleData.channels?.length === 0 && liveScheduleData.schedules?.length === 0) {
          setIsNoScheduleAvailableModal(true);
        } else {
          setIsNoScheduleAvailableModal(false);
        }
      }
    }
    setIsCategoryChange(false);
    return () => localStorage.setItem("initialScheduleAdded", "false")
  }, [selectedSchedule, liveScheduleData, c]);

  useEffect(() => {
    // if (channelData?.live_link) {
      setShowSubscribe(false);
      checkSubscription();
      setIsLivePlaying(true);
      setIsLivePaused(false);
    // }
  }, [channelData, userSubscriptionData?.data]);

  useEffect(() => {
    if (fastchannelData?.now_playing?.end_time) {
      let time = getCurrentTimeAndDate();
      let currentTime = moment(time);
      let convertedEndTime = moment(fastchannelData?.now_playing?.end_time);
      let diff = convertedEndTime.diff(currentTime, "minutes");
      if (diff > 60) {
        setTimeLeft(timeConversion(diff));
      } else if (diff > 0) {
        let leftTime = diff + "m";
        setTimeLeft(leftTime);
      } else {
        setTimeLeft(null);
      }
    } else {
      setTimeLeft(null);
    }
  }, [fastchannelData]);

  useEffect(() => {
    if (fastchannelData?.now_playing?.start_time) {
      const interval = setInterval(() => {
        let diff = timeDifferenceHandler()
        if (diff > 60) {
          setTimeLeft(timeConversion(diff))
        } else if (diff > 0) {
          let leftTime = diff + "m"
          setTimeLeft(leftTime)
        }
      }, 60000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [fastchannelData, timeLeft])

  const timeDifferenceHandler = () => {
    let time = getCurrentTimeAndDate()
    let currentTime = moment(time)
    let convertedEndTime = moment(fastchannelData?.now_playing?.end_time)
    let differenceInMinutes = convertedEndTime.diff(currentTime, "minutes")
    return differenceInMinutes
  }



  useEffect(() => {
    if (liveUrl) {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        playsinline: true,
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${liveUrl}`,
            type: "application/x-mpegURL",
          },
        ],
        poster: { channelPoster }
      };
      setLivePlayer(
        <VideoJS options={videoJsOptions} liveData={fastchannelData} onReady={handlePlayerReady}  is_live={true}  poster={channelPoster} isRadioLive={isRadioLive}  />
      );
    }
    else {
      setLivePlayer(null);
    }
  }, [liveUrl]);

  useEffect(() => {
    window.scroll(0, 0)
    fetchUserSubscriptionDetails();
    fetchLiveCategories();

  }, []);
  const fetchLiveCategories = async () => {

    // const fastChannelResponse = await ( projectInfo?.projectConfig?.pubid === 50141 ? fetchLiveChannels2(appInfo) : fetchLiveChannels(appInfo) );
    const fastChannelResponse = await fetchLiveChannels(appInfo);
    if (fastChannelResponse.status === 200) {
      const fetchedCategories = fastChannelResponse?.data?.data?.categories;
      setCategories(fetchedCategories);
      const firstCategory = fetchedCategories?.[0];
      if (firstCategory) {
        setSelectedCategory(firstCategory);
        setselectedCategoryName(firstCategory.category_name);
      }
      setPageLoading(false);
    }
  }
  const fetchUserSubscriptionDetails = async () => {
    const userSubResponse = await getUserSubscription(appInfo);
    if (userSubResponse?.status === 200) {
      dispatch(
        getUserSubscriptionData({
          userSubscription: userSubResponse?.data,
        })
      );
    }
  };
 

  const checkSubscription = async () => {
    setIsContinueWithSubscriptionModal();
    // const channelId = c ? c : location?.state?.homelive === true && location?.state?.channelId;
    
    // console.log(channelId,"channelId");

    let channelId;
    if (c) {
      channelId = c;
    } else if (location?.state?.homelive === true && location?.state?.channelId) {
      channelId = location.state.channelId;
    } else if (channelData?.channel_id) {
      channelId = channelData.channel_id;
    } else {
      channelId = null;
    }

    if (!channelId) {
      setIsContinueWithSubscriptionModal(true);
      return;
    }
    
    const appInfo = {
      projectDetails: projectInfo,
      accessToken: accessToken,
    };

    const videoSubRespone = await getVideoSubscription(appInfo, channelId, 'channel');
    setVideoSubscription(videoSubRespone);
    const isSubscribedUser = matchSubscription(userSubscriptionData?.data, videoSubRespone?.data?.data)

    setSubscribedUser(isSubscribedUser);
    const fastChannelResponse = await fetchFastChannels(appInfo, channelId);
    setLiveVideoSub(fastChannelResponse?.data.data[0].subscriptions);
    let fastchannelInfo;

    if (fastChannelResponse?.status === 200) {
      fastchannelInfo = fastChannelResponse?.data?.data?.[0];

      if (fastchannelInfo) {
        setFastChannelData({ ...fastchannelInfo });

        if (fastchannelInfo?.logo) {
          setChannelPoster(fastchannelInfo.logo_thumb);
        } else {
          setChannelPoster(projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE)
        }

        setTimeout(() => {
          setShowSubscribe(true);
        }, 2000);

        // if (fastchannelInfo?.audio_only) {
        //   setIsRadioLive(true);
        // }
      }
    }
    if (videoSubRespone?.data?.data.length == 0) {
      setLiveUrl(fastchannelInfo?.live_link);
    } else {
      if (isSubscribedUser === true) {
        setLiveUrl(fastchannelInfo?.live_link);
      } else {
        setIsContinueWithSubscriptionModal(true);
      }
    }


  }

  const matchSubscription = (userSub, videoSub) => {
    const hasMatch = videoSub.length == 0 ? true : userSub.some((user) => videoSub.some((video) => user.sub_id === video.subscription_id));
    return hasMatch;
  };


  const handlePlayerReady = (player) => {
    playerRef.current = player;

    player.on("play", () => {
      let event = videoStarted == true ? "POP09" : "POP02";
      videoStarted = true;
      updateLiveAnalytics(
        channelData,
        event,
        player.currentTime()
      );
    });

    player.on("timeupdate", function (e) {
      let event = "POP03";

      var hasPlayedTime = player.currentTime();
      var intPlayedTime = parseInt(hasPlayedTime, 10);
      var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
      if (isSixty && debounce) {
        debounce = false;
        prevTime = intPlayedTime;
        updateLiveAnalytics(
          channelData,
          event,
          player.currentTime()
        );
      } else {
        if (debounce == false && prevTime != intPlayedTime) {
          debounce = true;
        }
      }
    });

    player.on("pause", () => {
      let event = "POP04";
      updateLiveAnalytics(
        channelData,
        event,
        player.currentTime()
      );
    });
    player.on("ended", () => {
      let event = "POP05";
      updateLiveAnalytics(
        channelData,
        event,
        player.currentTime()
      );
    });


    player.on("dispose", () => {
      videoStarted = false;
      // player.pause();
    });
  };

  const updateLiveAnalytics = async (nowPlaying, event, time) => {
    const isLive = "1";
    const updateResponse = await onVideoPlayFunction(
      appInfo,
      nowPlaying,
      event,
      time,
      isLive
    );
  };

  const readMoreOrLessHandler = (type) => {
    if (type === "more") {
      if (channelData?.video_description) {
        setSliceCount(channelData?.video_description?.length);
        setIsReadMore(false);
      }
    } else {
      setSliceCount(550);
      setIsReadMore(true);
    }
  };

  const ContinueWatchingHandler = async () => {
    localStorage.setItem('initialLoaded', 'true');
    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true') {
      navigate("/checkout", { state: { channelId: channelData?.channel_id } });
    } else {

      if (!user) {
        navigate("/login", { state: { path: location?.pathname } });
      } else {
        navigate("/subscription", {
          state: { channelId: channelData?.channel_id },
        });
      }
    }
  };
  const handleCategorySelection = (item) => {
    setIsCategoryChange(true);
    setSelectedCategory(item);
    setselectedCategoryName(item?.category_name);
    setCategoryButton(false);
  };
  const handleWatchNowLive = () => {
    if (fastchannelData?.live_link) {
      setLiveUrl(fastchannelData.live_link);
      setIsLivePlaying(true);
      setIsLivePaused(false);
    }
    const videoContainer = document.querySelector('.videoContainer');
    if (videoContainer) {
      videoContainer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePauseLive = () => {
    setIsLivePaused(true);
    setIsLivePlaying(false);
  };

  const categoriesRowRef = useRef(null);

const handleLeftScroll = () => {
  if (categoriesRowRef.current) {
    categoriesRowRef.current.scrollBy({ left: -200, behavior: 'smooth' });
  }
};

const handleRightScroll = () => {
  if (categoriesRowRef.current) {
    categoriesRowRef.current.scrollBy({ left: 200, behavior: 'smooth' });
  }
};

useEffect(() => {
  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };
  
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

  // if(!isReady){
  //   return <Loading />
  // }

  if (pageLoading) {
    return <MainLoading />;
  }

  return (
    <div className="kalingoLiveChannelsContainer">
          {scheduleModal?.isOpen && <ScheduleDetailsModal />}

          {isContinueWithSubscriptionModal && (<ContinueWithSubscriptionModal
              setIsContinueWithSubscriptionModal={setIsContinueWithSubscriptionModal}
              channelData={channelData}
              appInfo={appInfo}
            />
          )}
          
          {isNoScheduleAvailableModal && <NoScheduleAvailableModal />}
          {
            console.log( channelData," channelData")
            
          }
          {
          !loading && 
            // pubid?.toString() === "50120" ? (
            //   <LivePlayerCenter
            //     loading={loading}
            //     channelData={channelData}
            //     fastchannelData={fastchannelData}
            //     timeLeft={timeLeft}
            //     livePlayer={livePlayer}
            //     projectInfo={projectInfo}
            //     isLiveVideoSub={isLiveVideoSub}
            //     subscribedUser={subscribedUser}
            //   />
            // ) :
             (
            <div className="topContainer">
              <div className="wrapper">
                <div className="bannerContainer">
                {fastchannelData &&
                <>
                  <div className="info">
                 {fastchannelData?.channel_name && <h1 className="title">Channel: {fastchannelData?.channel_name}</h1>}
                 <h2 className="videotitle">{fastchannelData?.now_playing?.video_title}</h2>
                    <p className="description">
                     
                      {fastchannelData?.now_playing?.description && (
                        <>
                          {parse(
                            fastchannelData?.now_playing?.description
                              ?.slice(0, sliceCount)
                              ?.split("\n")
                              ?.join("<br>")
                          )}
                          {fastchannelData?.now_playing?.description?.length > sliceCount && (
                            <>
                              {isReadMore ? (
                                <>
                                  <span>...</span>
                                  <span className="readMore" onClick={() => readMoreOrLessHandler("more")}>
                                    <Translate textKey={'read_more'}/>
                                  </span>
                                </>
                              ) : null}
                            </>
                          )}
                          {!isReadMore && (
                            <span className="readLess" onClick={() => readMoreOrLessHandler("less")}>
                              <Translate textKey={'read_less'}/>
                            </span>
                          )}
                        </>
                      )}
                    </p>
                     {/* <div className="liveLabel">
                        <LiveIcon />
                        <span><Translate textKey={'live_caps'}/></span>
                      </div> */}
                    <div className="additionalInfo">
                      {(fastchannelData?.rating || timeLeft || fastchannelData?.categories) && <h1 className="title">WATCH LIVE TV</h1>}
                      <ul>
                        {fastchannelData?.rating && <li>{fastchannelData?.rating}</li>}
                        {timeLeft && <li>{timeLeft} <Translate textKey={'left_small'}/></li>}
                        {fastchannelData?.categories[0] && <li>{fastchannelData?.categories[0]?.category_name}</li>}
                      </ul>
                      {channelData?.rating && <span className="rating">{channelData?.rating}</span>}
                    </div>
                  </div>
                  <div className="buttonsContainer">
                    <div className="live-button"> 
                        {isLivePlaying && !isLivePaused ? (
                        <button onClick={handlePauseLive}><PauseButton /> LIVE</button>
                        ) : (
                        <button onClick={handleWatchNowLive}><PlayButton /> LIVE</button>
                        )}
                    </div>
                    {/* <div className="live-button">
                        <button >Add to Favourites</button>
                    </div> */}
                    {/* <div className="live-button"> 
                        <button >Region</button>
                    </div>                    */}
                  </div>
                  </>}
                </div>
                <div className="videoContainer">
                  {isLivePlaying && !isLivePaused && liveUrl && (isLiveVideoSub?.length === 0 || subscribedUser) && livePlayer ? (
                    livePlayer
                  ) : (
                    <div className="videoImageContainer" style={{ width: '100%' }}>
                      <div className="banner-image" style={{ width: '100%'}}>
                        {fastchannelData?.logo ? (
                          imageUrlCheck(fastchannelData?.logo) ? (
                            <img src={fastchannelData?.logo} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          ) : (
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}${fastchannelData?.logo}`}
                              alt="Logo"
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          )
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
          }

          {categories && categories.length > 0 && (
            <div className="categories-row-wrapper">
              <button className="arrow-btn left category-arrow-btn">
                <span><RightArrow /></span>
              </button>
              <Swiper
                slidesPerView="auto"
                spaceBetween={10}
                navigation={{
                  nextEl: '.arrow-btn.right.category-arrow-btn',
                  prevEl: '.arrow-btn.left.category-arrow-btn',
                }}
                className="categories-row"
              >
                {categories.map((item, index) => (
                  <SwiperSlide key={index} style={{ width: 'auto' }}>
                    <div
                      className={`category-btn${selectedCategory?.category_id === item?.category_id ? ' selected' : ''}`}
                      onClick={() => handleCategorySelection(item)}
                    >
                      <span>{item?.category_name}</span>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <button className="arrow-btn right category-arrow-btn">
                <span><RightArrow /></span>
              </button>
            </div>
          )}

          {projectInfo?.projectConfig?.pubid === 50141 && liveScheduleData?.channels && liveScheduleData.channels.length > 0 && (
            <div className="categories-row-wrapper">
              <button className="arrow-btn left channel-arrow-btn">
                <span><RightArrow /></span>
              </button>
              <Swiper
                slidesPerView="auto"
                spaceBetween={10}
                navigation={{
                  nextEl: '.arrow-btn.right.channel-arrow-btn',
                  prevEl: '.arrow-btn.left.channel-arrow-btn',
                }}
                className="categories-row"
              >
                {liveScheduleData.channels.map((channel, idx) => (
                  <SwiperSlide key={channel.id || idx} style={{ width: 'auto' }}>
                    <div
                      className="channel-logo-btn"
                      onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        dispatch({ type: 'selectedChannel/getSelectedChannel', payload: { selectedChannel: { channel_id: channel.id } } });
                        dispatch({ type: 'selectedSchedule/getSelectedSchedule', payload: { selectedSchedule: { channel_id: channel.id } } });
                        navigate("/live-channels?c=" + channel.id, { state: { channel_id: channel.id, homelive: true } });
                      }}
                    >
                      <img
                        src={channel.logo ? channel.logo : projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE}
                        alt={channel.channel_name || 'Channel'}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <button className="arrow-btn right channel-arrow-btn">
                <span><RightArrow /></span>
              </button>
            </div>
          )}

          <LiveEpgContainer 
            selectedCategory={selectedCategory}
          />
    </div>
  );
};

export default KalingoLiveChannels;
